export default __webpack_public_path__ + "static/media/two.f79226af.svg";